import { useMemo } from "react";
import { format } from "date-fns";
import { apiGet } from "../utils/apiClient";

/**
 * Retrieves SpecialRouteBusBlocks data.
 * @returns - A promise that resolves to the SpecialRouteBusBlocks data.
 */
export const useSpecialRouteBusBlocks = () => {
  const memoizedSpecialRouteBusBlocks = useMemo(
    () => async (assignmentDate, rowFilter, pulloutDivision) => {
      const apiDate = format(assignmentDate, "dd-MMM-yyyy");
      return apiGet(
        `/SpecialRouteBusBlocks/${apiDate}/${rowFilter}/${pulloutDivision}`,
        "fetching Special Route Bus Blocks"
      );
    },
    []
  );

  return memoizedSpecialRouteBusBlocks;
};
